import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { createEssentials } from '@wix/fe-essentials-standalone';
import { RootEssentialsProvider } from '@wix/fe-essentials-standalone/react';
import i18n from './i18n';
import App from './components/App';
import {
  accountLogo,
  comments,
  editorType,
  locale,
  isPartner,
  siteUrl,
  pages,
  siteHeaderHeight,
  scriptsTopology,
  breakpoints,
  user,
  feedbackId,
  siteName,
  metaSiteId,
  pMetaSiteId,
  siteId,
  ownerId,
  feedbackCreatorUserGuid,
  error,
  experiments,
  linkKey,
  ownerName,
} from './fromWindow';
import { AppContextProvider } from '@components/Contexts/AppContext';
import { WixDesignSystemProvider } from '@wix/design-system';
import * as Sentry from '@sentry/browser';
import { getAppUrl, getAppVersion } from '@wix/experts-common';
import '@wix/design-system/styles.global.css';

const FEEDBACK_DASHBOARD_DSN =
  'https://fc9318231f1948f5b42e8974363f649a@sentry.wixpress.com/5531';

Sentry.init({
  dsn: FEEDBACK_DASHBOARD_DSN,
  release: getAppVersion(getAppUrl('experts-feedback-viewer')),
  environment: 'experts-feedback-viewer',
});

const baseURL = `${window.location.origin}/__feedback`;

console.log('baseURL', baseURL);

const essentials = createEssentials({
  environment: {
    artifactId: 'experts-feedback-viewer',
    language: locale,
    version: '',
  },
  experiments: { bag: experiments },
  fedops: {},
  errorMonitor: {
    dsn: FEEDBACK_DASHBOARD_DSN,
  },
  httpClient: {
    baseURL,
  },
});

const feedbackProps = {
  locale,
  accountLogo,
  comments,
  editorType,
  siteUrl,
  isPartner,
  pages,
  siteHeaderHeight,
  scriptsTopology,
  breakpoints,
  user,
  feedbackId,
  siteName,
  metaSiteId,
  pMetaSiteId,
  siteId,
  ownerId,
  feedbackCreatorUserGuid,
  error,
  experiments,
  linkKey,
  ownerName,
};

ReactDOM.render(
  <Suspense fallback="">
    <RootEssentialsProvider essentials={essentials}>
      <I18nextProvider i18n={i18n(locale)}>
        <WixDesignSystemProvider
          features={{ newColorsBranding: true }}
          as="span"
        >
          <AppContextProvider {...feedbackProps}>
            <App />
          </AppContextProvider>
        </WixDesignSystemProvider>
      </I18nextProvider>
    </RootEssentialsProvider>
  </Suspense>,
  document.getElementById('root'),
);
